import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as correctionReducer, REDUCER_NAME as CORRECTION_REDUCER_NAME } from './correction'
import { reducer as displayReducer, REDUCER_NAME as DISPLAY_REDUCER_NAME } from './display'


const reducer = combineReducers({
    [CORRECTION_REDUCER_NAME]: correctionReducer,
    [DISPLAY_REDUCER_NAME]: displayReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/invoice/state/index.js